import { FacebookService } from 'src/app/services/social/facebook.service';

class FacebookHandler {

    constructor(
        private facebookService: FacebookService,
    ) {

    }

    processPost(raw_post) {
        const date = new Date(raw_post.created_time);
        return {
            ...raw_post,
            date: `${date.toLocaleDateString()} ${date.toLocaleTimeString()}`,
            is_handled: false,
            sender: raw_post.from.name,
            senderId: raw_post.from.id,
            service: 'facebook',
        }
    }
}

export default FacebookHandler;